import React, { useCallback, useState } from "react";
import { FormControl, Select, MenuItem, InputLabel, TextField, InputAdornment } from "@material-ui/core";
import clsx from "clsx";
import { Autocomplete } from "@mui/material";
import WaveXchangeIcon from "../../assets/images/wavexchange-small-icon.svg";
import { NEW_GROUP_DROPDOWN } from "../../utils/appConstants";

interface DropdownProps {
  value: string;
  inputValue: string;
  options: string[];
  disabled?: boolean;
  autoFocus?: boolean;
  onNetNames?: string[];
  onChange: (value: string) => void;
  onInputChange: (value: string) => void;
  className?: string;
  title?: string;
}

const Dropdown: React.FC<DropdownProps> = ({ onChange, onInputChange, value, autoFocus, inputValue, options, disabled, onNetNames, className, title }) => {
  const addStartIcon = (params: any) => {
    params.InputProps.startAdornment = inputValue && onNetNames && (
      <InputAdornment position="start">
        {inputValue && onNetNames && onNetNames.includes(inputValue) ? <img src={WaveXchangeIcon} alt="fabricon" /> : ""}
      </InputAdornment>
    );
    return params;
  };
  const ref = React.useRef(null);

  return (
    <div className={`d-dropdown ${className}`}>
      <Autocomplete
        selectOnFocus
        autoHighlight
        autoComplete
        disablePortal
        id="combo-box-demo"
        options={options}
        renderInput={(params) => (
          <TextField
            inputRef={ref}
            autoFocus={autoFocus}
            {...addStartIcon(params)}
            margin="none"
            label={<div>{title}</div>}
            style={{ padding: "0.5vh 0.5vw", width: "calc(100% - 1vw)" }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props}>
            {option && onNetNames && onNetNames.includes(option) && <img src={WaveXchangeIcon} alt="fabricon" style={{ marginRight: "5px" }} />}
            {option}
          </li>
        )}
        disabled={disabled}
        value={value || ""}
        onChange={(event: any, newValue: string | null) => {
          if (newValue === NEW_GROUP_DROPDOWN) {
            try {
              // @ts-ignore
              ref && ref.current && ref.current.blur();
              // console.log(ref.current);
            } catch {}
          }
          onChange && onChange(newValue || "");
        }}
        inputValue={inputValue || ""}
        onInputChange={(event, newInputValue) => {
          onInputChange && onInputChange(newInputValue || "");
        }}
      />
    </div>
  );
};

export default Dropdown;
